import { metricsActions } from "../../slice/efe/metricsSlice";
import { Axios } from "../../../axiosHelper";
import { AxiosError, AxiosResponse } from "axios/index";
import { ResponseBase } from "../../data";
import {
  AddMetricsRequest,
  MetricJsonGenApiResponse,
  MetricListResponse
} from "../../data/metrics";

export const getMetricsList = (systemId: string): any => {
  return async (dispatch: any) => {
    dispatch(metricsActions.setLoading(true));

    Axios.get("/efe/metrics/list/" + systemId)
      .then((res: AxiosResponse<MetricListResponse>) => {
        dispatch(metricsActions.setMetricsList(res.data.metricsList));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(metricsActions.setError(resp));
          }
        }
      });
  };
};

export const getMetricJsonGen = (podId: string): any => {
  return async (dispatch: any) => {
    dispatch(metricsActions.setLoading(true));

    Axios.get("/efe/metrics/metric-json-gen/" + podId)
      .then((res: AxiosResponse<MetricJsonGenApiResponse>) => {
        dispatch(metricsActions.setMetricJsonGenResponse(res.data.metricJsonGenResponse));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(metricsActions.setError(resp));
          }
        }
      });
  };
};

export const addNewMetrics = (request: AddMetricsRequest): any => {
  return async (dispatch: any) => {
    dispatch(metricsActions.setLoading(true));

    Axios.post("/efe/metrics/new", request, {
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((res: AxiosResponse<ResponseBase>) => {
        dispatch(metricsActions.setResponse(res.data));
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(metricsActions.setError(resp));
          }
        }
      });
  };
};

export const clearMetricsResponse = (): any => {
  return async (dispatch: any) => {
    dispatch(metricsActions.setResponse(null));
  };
};

export const clearMetricsError = (): any => {
  return async (dispatch: any) => {
    dispatch(metricsActions.setError(null));
  };
};

export const clearMetricJsonGenResponse = (): any => {
  return async (dispatch: any) => {
    dispatch(metricsActions.setMetricJsonGenResponse(null));
  };
};
